<template>
  <div class="select_times">
    <ul class="multi-checkbox">
      <li v-for="(item, index) in items" :key="index">
        <label>
          <input
            type="checkbox"
            v-model="selected[index]"
            @change="emitValue(index)"
          />
          <span>{{ item }}</span>
        </label>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["items", "value"],
  data() {
    return {
      selected: []
    };
  },
  methods: {
    init() {
      this.selected.length = this.items.length;
      this.selected.fill(false);
    },
    emitValue(index) {
      // console.log("emited");
      this.selected.fill(false)
      this.selected[index] = true
      this.$emit("input", this.valueToItems);
    }
  },
  computed: {
    valueToItems() {
      let arr = [];
      for (let i = 0; i < this.items.length; i++) {
        if (this.selected[i] === true) {
          arr.push(this.items[i]);
        }
      }
      return arr;
    }
  },
  mounted() {
    this.init();
  }
};
</script>
